import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SFacebook component used for Facebook social network.
 * @link https://www.facebook.com/
 * @example https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgithub.com%2F&quote=Quote&hashtag=%23Github
 */
/**
 * Share parameters for link
 * @link https://developers.facebook.com/docs/workplace/sharing/share-dialog/
 */

var SFacebook = /* #__PURE__ */defineComponent({
  name: 'SFacebook',
  mixins: [BaseSocials('Facebook', {
    width: 685,
    height: 600
  })],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://www.facebook.com/sharer/sharer.php';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url,
          quote = shareOptions.quote,
          hashtag = shareOptions.hashtag;
      return "".concat(BASE_URL).concat(getSerialisedParams({
        u: url,
        quote: quote,
        hashtag: hashtag
      }));
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SFacebook;
